import { styled, AppBar as MuiAppBar, Toolbar as MuiToolbar } from '@mui/material';
import styles from 'assets/jss/styles';

export const AppBar = styled(MuiAppBar)(({ theme }) => ({
  marginBottom: '0',
  width: 'calc(100% + 10px)',
  zIndex: '1029',
  color: theme.palette.primary.main,
  border: '0',
  borderRadius: '3px',
  transition: 'all 150ms ease 0s',
  minHeight: '50px',
  display: 'block',
  overflow: 'hidden',
  '@media (max-width: 80px)': {
    position: 'relative',
    backgroundColor: theme.palette.sideMenu.bgColor + '!important',
    padding: 0
  },
  backgroundColor: styles(theme)?.topBarBkColor,
  ...styles(theme)?.themeBoxSecondaryShadow
}));

export const Toolbar = styled(MuiToolbar)(({ theme }) => ({
  ...styles(theme)?.containerFluid,
  paddingLeft: `${theme.spacing(3)} !important`,
  paddingRight: `${theme.spacing(4)} !important`,
  minHeight: '50px',
  '@media (max-width: 80px)': {
    display: 'flex',
    flexDirection: 'column'
  }
}));

export const MinimizeSidebar = styled('div')(() => ({
  float: 'left',
  paddingBlock: '10px',
  paddingRight: '15px',
  display: 'block',
  color: '#555555'
}));

export const HeaderResponsive = styled('div')(() => ({
  paddingBlock: '10px',
  paddingLeft: '10px',
  '@media (max-width: 80px)': {
    position: 'absolute',
    padding: '5px 15px',
    right: 0,
    top: 0
  }
}));
